import React from 'react';
import StandardCriteriaDisplay from './StandardCriteriaDisplay';
import ClassCriteriaDisplay from './ClassCriteriaDisplay';
import './CriteriaComparisonView.css';

/**
 * CriteriaComparisonView - Wrapper that displays Standard and Class criteria together
 * @param {Object} props
 * @param {string} props.type - "formulary" or "medical"
 * @param {Object} props.standardData - Standard criteria data
 * @param {Object} props.classData - Class criteria data
 * @param {boolean} props.standardLoading - Standard criteria loading state
 * @param {boolean} props.classLoading - Class criteria loading state
 * @param {string} props.standardError - Standard criteria error message
 * @param {string} props.classError - Class criteria error message
 * @param {boolean} props.notCovered - Whether the drug is not covered (formulary only)
 */
const CriteriaComparisonView = ({
  type,
  standardData,
  classData,
  standardLoading,
  classLoading,
  standardError,
  classError,
  notCovered = false
}) => {
  // If formulary and not covered, show special message
  if (type === 'formulary' && notCovered) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-6 text-center space-y-4">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
          <svg className="h-8 w-8 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16v-4m0-4h.01" />
          </svg>
        </div>
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-foreground">
            Pharmacy Benefit Criteria Not Provided
          </h3>
          <p className="text-sm text-muted-foreground max-w-md">
            This drug is not covered under the pharmacy benefit for this plan. Coverage criteria are not specified.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="criteria-comparison-view">
      {/* Standard Criteria on top */}
      <StandardCriteriaDisplay
        type={type}
        stDetail={standardData?.result?.STDetail || null}
        paDetail={standardData?.result?.PADetail || null}
        loading={standardLoading}
        error={standardError}
        title="Standard Criteria"
      />

      {/* Class Criteria below */}
      <ClassCriteriaDisplay
        criteria={classData?.result?.ClassCriteria || null}
        loading={classLoading}
        error={classError}
        title="Class Criteria"
      />
    </div>
  );
};

export default CriteriaComparisonView;
